// TemplateFreeLabel.js
import React from 'react';

/**
 * A component to display a "Free" label on template previews
 * @param {Object} props
 * @param {string} props.templateName - The name of the template
 * @param {Array} props.freeTemplates - List of template names that are free
 * @param {string} props.position - Position of the label (default: 'bottom-right')
 */
const TemplateFreeLabel = ({ 
  templateName, 
  freeTemplates = ['Aspirations', 'Proactive', 'Executive'],
  position = 'bottom-right'
}) => {
  // Check if the template is in the free templates list
  const isFreeTemplate = freeTemplates.includes(templateName);
  
  // If it's not a free template, don't render anything
  if (!isFreeTemplate) return null;
  
  // Determine position classes based on the position prop
  let positionClasses = 'absolute';
  
  switch(position) {
    case 'top-left':
      positionClasses += ' top-1 left-1';
      break;
    case 'top-right':
      positionClasses += ' top-1 right-1';
      break;
    case 'bottom-left':
      positionClasses += ' bottom-1 left-1';
      break;
    case 'bottom-right':
    default:
      positionClasses += ' bottom-2 right-2';
      break;
  }
  
  return (
    <div className={`${positionClasses} z-10`}>
      <span className="bg-gray-400 text-white px-2 py-1 rounded-xl text-xs">
        Free
      </span>
    </div>
  );
};

export default TemplateFreeLabel;